import { render, staticRenderFns } from "./EducationalGroupClose.vue?vue&type=template&id=0afb954e&"
import script from "./EducationalGroupClose.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports